import * as TYPES from './types';

const mutations = {
    [TYPES.SET_COUMT_ADD](state, value) {
        if(value){
            state.count += value
        }else{
            state.count ++
        }
    },
    // 详情页ID
    [TYPES.SET_DETAILS_ID](state, value) {
        state.detailsID = value;
    },
    // 保存appkey
    [TYPES.SET_APP_KEY](state, value) {
        state.appKey = value;
    },
    // 搜索关键词
    [TYPES.SET_SEARCH_WORD](state, value) {
        state.searchWord = value;
    },
}
export default mutations